module.exports = __webpack_public_path__ + "img/logo.3ced9f03.png";